<template>
  <footer class="footer-area bg-color">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 col-md-6 col-sm-6">
          <div class="single-footer-widget">
            <router-link to="/" class="logo">
              <img src="../assets/images/as-logo.png" alt="logo" />
            </router-link>
            <p>
              Transformăm ideile tale în soluții software performante pentru afaceri moderne.
            </p>
            <ul class="social-link">
              <li>
                <a href="https://www.facebook.com/atelieruldesoftware" class="d-block" target="_blank"
                  ><i class="bx bxl-facebook"></i
                ></a>
              </li>
              <li>
                <a href="https://wa.me/40743560022" class="d-block" target="_blank"
                  ><i class="bx bxl-whatsapp"></i
                ></a>
              </li>
            </ul>
            <router-link to="/SoftOne" class="logo">
              <img src="../assets/images/authorized.png" alt="logos1" />
            </router-link>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="single-footer-widget">
            <h3>Informații de contact</h3>
            <ul class="footer-contact-info">
              <li>
                <i class="bx bx-envelope"></i
                ><a href="mailto:contact@atelieruldesoftware.ro">contact@atelieruldesoftware.ro</a>
              </li>
              <li>
                <i class="bx bx-time-five"></i
                ><p>Luni - Vineri: 09:00 - 17:00</p>
              </li>
              <li>
                <i class="bx bx-buildings"></i><strong>Total Business Consulting SRL</strong>
              </li>
              <li>
                <i class="bx bx-map"></i>Strada Vasile Lupu, nr. 36, Ploiești, jud. Prahova
              </li>
              <li>
                <i class="bx bxl-whatsapp"></i
                ><a href="https://wa.me/40740277201" target="_blank">(+40) 740 277201</a>
              </li>
              <li>
                <i class="bx bx-buildings"></i><strong>Self Promote SRL</strong>
              </li>
              <li>
                <i class="bx bx-map"></i>Strada Andrei Mureșanu, nr. 88, Bistrița, jud. Bistrița-Năsăud
              </li>
              <li>
                <i class="bx bxl-whatsapp"></i
                ><a href="https://wa.me/40743560022" target="_blank">(+40) 743 560022</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-6">
          <div class="single-footer-widget pl-5">
            <h3>Explorează</h3>
            <ul class="footer-links-list">
              <!-- <li><a href="#acasa" @click.prevent="scrollToTarget('#acasa')">Acasă</a></li> -->
              <li><a href="#despre-noi" @click.prevent="scrollToTarget('#despre-noi')">Despre noi</a></li>
              <li><a href="#serviciile-noastre" @click.prevent="scrollToTarget('#serviciile-noastre')">Servicii</a></li>
              <li><a href="#metoda-atelierului" @click.prevent="scrollToTarget('#metoda-atelierului')">Mod de lucru</a></li>
              <li><a href="#clientii-nostri" @click.prevent="scrollToTarget('#clientii-nostri')">Clienți</a></li>
              <li><a href="#echipa-noastra" @click.prevent="scrollToTarget('#echipa-noastra')">Echipa</a></li>
              <li><router-link to="/SoftOne">SoftOne</router-link></li>
              <li><router-link to="/SoftOne#testeaza">Testează SoftOne ERP</router-link></li>
              <li><a href="#contact" @click.prevent="scrollToTarget('#contact')">Contactează-ne</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-map">
      <img src="../assets/images/footer-map.png" alt="image" />
    </div>
  </footer>
</template>

<script>

export default {
  name: "ASFooter",
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {
    scrollToTarget(target) {
        const element = document.querySelector(target);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
  },
};
</script>

<style scoped>
.authorized-logo-wrapper {
  text-align: left;
  margin-top: 20px;
}
</style>